import { memo } from "react"
import { mdlPmsIntegrationData } from "../../models/domain/PmsIntegrationData"
import { Table, TableProps } from "antd"
import { t } from "i18next"

export type PmsIntegrationsTableProps = {
    dataSource?: mdlPmsIntegrationData[]
}

export const PmsIntegrationsTable = memo(function PmsIntegrationsTable(props: PmsIntegrationsTableProps) {
    const columns: TableProps<mdlPmsIntegrationData>["columns"] = [
        {
            title: t("pmsIntegrations.logo"),
            dataIndex: "imageLink",
            key: "imageLink",
            render: (_: string, record: mdlPmsIntegrationData) => (
                <img alt={record.name} src={record.imageLink} />
            ),
            width: "100px"
        },
        {
            title: t("pmsIntegrations.company"),
            dataIndex: "name",
            key: "name",
            className: "bold-text"            
        }
    ];

    return (
        <>
            {
                props.dataSource
                &&
                <Table<mdlPmsIntegrationData>
                    className="mt-2"
                    size="middle"
                    columns={columns}
                    dataSource={props.dataSource.map((pmsIntegrationData: mdlPmsIntegrationData, index: number) => ({ ...pmsIntegrationData, key: index }))}
                />
            }
        </>
    );
})